export class CappingError extends Error {
    constructor(code, message) {
        super(message);
        this.name = 'CappingError';
        this.message = message;
        this.code = code;
    }
}
//# sourceMappingURL=capping.js.map